import { DataLayerEvent } from 'interfaces/DataLayerEvent'

export default function pushToDataLayer(data: DataLayerEvent) {
  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push(data)
}
